export const getSearchParams = (inputValue: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append('q', inputValue);

  return searchParams;
};
